import React from 'react'
import { Link } from 'react-router-dom'
import { useNewHomeAPI } from '../../hooks/useAllCategoryData';

const Instagram = () => {
    const { isLoading, error, data } = useNewHomeAPI();
  if (error) return <div>{error.message}</div>;
  return (
    <div className='insat-wrap'>
        <div className='container'>
            <div className='instalogo'>
                {/*<div className='logo-box'><Link to="https://www.instagram.com/chaashni.couture/" target='_blank'><img src='/images/New-Logo.jpg' alt=''/></Link></div>
                 <div className='logo-text'><Link to="https://www.instagram.com/chaashni.couture/" target='_blank'>CHAASHNI : Customized Luxury Wear for Her
                <small>@chaashni.couture</small></Link></div> */}
                <div className='logo-box'><Link to="https://www.instagram.com/chaashni.couture/" target='_blank'><img src={`${process.env.REACT_APP_IMAGE_URL}/home/insta/insta.png`} alt=''/></Link></div>
                <div className='logo-text'><Link to="https://www.instagram.com/chaashni.couture/" target='_blank'><img src='' alt=''/>Chaashni Couture <small>@chaashni.couture</small></Link></div>                
            </div>
        </div>
        {data?.insta && (
        <div className='container'>
            <div className='insta-box has-four'>
                {data.insta.left.map((e,i)=>(
                    <div className='instaimg' key={i}><Link to={e.url} target='_blank'><img src={`${process.env.REACT_APP_IMAGE_URL}/home/insta/${e.image}`} alt=''/></Link></div>               
                ))}
            </div>

            <div className='insta-box has-one'>
                <div className='instaimg'><Link to={data.insta.center[0].url} target='_blank'><img src={`${process.env.REACT_APP_IMAGE_URL}/home/insta/${data.insta.center[0].image}`} alt=''/></Link></div>                
            </div>

            <div className='insta-box has-four'>
            {data.insta.right.map((e,i)=>(
                <div className='instaimg' key={i}><Link to={e.url} target='_blank'><img src={`${process.env.REACT_APP_IMAGE_URL}/home/insta/${e.image}`} alt=''/></Link></div>
            ))}
            </div>
        </div>)}
    </div>
  )
}

export default Instagram
